import React, { useState } from 'react';
import { Modals } from '../Consts';
import { useAppContext } from '../AppContext';
import { Button, ButtonGroup, ModalPage, Spacing, Caption, Title } from '@vkontakte/vkui';
import './OnBoardingModal.css';
import { creditsImage } from '../img/OnBoarding/credits';
import { createEventImage } from '../img/OnBoarding/createEvent';
import { inviteFriendsImage } from '../img/OnBoarding/inviteFriends';
import { profileImage } from '../img/OnBoarding/profile';
import { notifyImage } from '../img/OnBoarding/notify';
import { createPaymentImage } from '../img/OnBoarding/createPayment';

const CURRENT_MODAL = Modals.ON_BOARDING_MODAL;

const OnBoardingModal = () => {
  const context = useAppContext();

  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      media: {
        type: 'image',
        blob: creditsImage,
      },
      title: context.lang().getKey('OnBoarding', 'slide_about_title'),
      subtitle: context.lang().getKey('OnBoarding', 'slide_about_text'),
    },
    {
      media: {
        type: 'image',
        blob: createEventImage,
      },
      title: context.lang().getKey('OnBoarding', 'slide_credits_title'),
      subtitle: context.lang().getKey('OnBoarding', 'slide_credits_text'),
    },
    {
      media: {
        type: 'blob',
        blob: createPaymentImage,
      },
      title: context.lang().getKey('OnBoarding', 'slide_create_payment_title'),
      subtitle: context.lang().getKey('OnBoarding', 'slide_create_payment_text'),
    },
    {
      media: {
        type: 'image',
        blob: inviteFriendsImage,
      },
      title: context.lang().getKey('OnBoarding', 'slide_friends_title'),
      subtitle: context.lang().getKey('OnBoarding', 'slide_friends_text'),
    },
    {
      media: {
        type: 'image',
        blob: profileImage,
      },
      title: context.lang().getKey('OnBoarding', 'slide_profile_title'),
      subtitle: context.lang().getKey('OnBoarding', 'slide_profile_text'),
    },
    {
      media: {
        type: 'image',
        blob: notifyImage,
      },
      title: context.lang().getKey('OnBoarding', 'slide_notify_title'),
      subtitle: context.lang().getKey('OnBoarding', 'slide_notify_text'),
    },
  ];

  const onFinish = (action) => {
    context.httpClient().passedOnBoarding();
    context.store.setPassedOnBoarding(true);

    context.getBridge().retargeting.onBoardingFinish(context.store.currentUserId, action);
    context.router.hideModal();
  }

  return (
    <ModalPage
      nav={CURRENT_MODAL}
      onClose={() => onFinish('cancel')}
    >
      <div className="Onboarding-module__container">
        <div className="Onboarding-module__mediaContainer Onboarding-module__mediaContainerWithAspectRatio">
          {
            slides.map((slide, index) => {
              if (index === currentSlide) {
                return <div
                  key={'image_slide_' + index}
                  className="OnboardingLoadableContent-module__container Onboarding-module__media"
                >
                  <img
                    className="OnboardingImage-module__image"
                    src={slide.media.blob}
                    alt={slide.title}
                  />
                </div>;
              }

              return <div
                key={'image_slide_' + index}
                className="OnboardingLoadableContent-module__container Onboarding-module__media Onboarding-module__visuallyHidden"
              >
                <img
                  className="OnboardingImage-module__image"
                  src={slide.media.blob}
                  alt={slide.title}
                />
              </div>;
            })
          }
        </div>

        <div className="Onboarding-module__content">
          <div className="Onboarding-module__steps" style={{width: (slides.length * 100) + '%', marginLeft: (currentSlide * -100) + '%'}}>
            {
              slides.map((slide, index) => {
                return <div className="Onboarding-module__step" key={'slide_' + index}>
                  <Title className={'Onboarding-module__title'} level={'2'}>
                    <div className="TextClamp-module__multiLine" style={{'--lines': 2}}>{slide.title}</div>
                  </Title>
                  <Spacing size={8}/>
                  <Caption className={'Onboarding-module__text'} level={'1'}>
                    <div className="TextClamp-module__multiLine" style={{'--lines': 3}}>{slide.subtitle}</div>
                  </Caption>
                </div>
              })
            }
          </div>
        </div>

        <Spacing size={4}/>

        <ButtonGroup
          className={'Onboarding-module__buttons'}
          mode="vertical"
          gap="s"
          stretched={true}
          align={'center'}
        >
          <Button
            stretched={true}
            size={'l'}
            onClick={() => {
              if (currentSlide === slides.length - 1) {
                return onFinish('confirm');
              }

              setCurrentSlide(currentSlide + 1);
            }}
          >
            {
              currentSlide === slides.length - 1 ? context.lang().getKey('OnBoarding', 'button_finish_label') : context.lang().getKey('OnBoarding', 'button_next_label')
            }
          </Button>
          <Button
            stretched={true}
            size={'l'}
            mode={'tertiary'}
            onClick={() => onFinish('reject')}
          >
            {context.lang().getKey('OnBoarding', 'button_skip_label')}
          </Button>

          <div
            className="Bullets-module__container Onboarding-module__bullets"
          >

            {
              slides.map((slide, index) => {
                if (index === currentSlide) {
                  return (<div
                    key={'bullet_slide_' + index}
                    tabIndex="0"
                    role="button"
                    className="Bullets-module__bullet Bullets-module__bulletSelected vkuiTappable vkuiTappable--sizeX-compact"
                    onClick={() => setCurrentSlide(index)}
                  >
                    <span aria-hidden="true" className="vkuiFocusVisible vkuiFocusVisible--inside"></span>
                  </div>);
                }

                return (<div
                  key={'bullet_slide_' + index}
                  tabIndex="0"
                  role="button"
                  className="Bullets-module__bullet vkuiTappable vkuiTappable--sizeX-compact"
                  onClick={() => setCurrentSlide(index)}
                >
                  <span aria-hidden="true" className="vkuiFocusVisible vkuiFocusVisible--inside"></span>
                </div>);
              })
            }

          </div>
        </ButtonGroup>
      </div>
    </ModalPage>
  );
}

export default OnBoardingModal;